import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

const HEARTBEAT_MS = 30000;
const CHECK_MS = 15000;

export function IdleManager() {
  const { logout } = useAuth();
  const nav = useNavigate();
  const lastActivity = useRef(Date.now());
  const timeoutMin = useRef(0);

  useEffect(() => {
    let hb, chk;
    let mounted = true;

    const bump = () => { lastActivity.current = Date.now(); };
    const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"];
    events.forEach((e) => window.addEventListener(e, bump, { passive: true }));

    api.get("/auth/session-policy").then(({ data }) => {
      if (!mounted) return;
      timeoutMin.current = data.applies ? data.idle_timeout_minutes : 0;
    }).catch(() => {});

    hb = setInterval(() => {
      const active = Date.now() - lastActivity.current < HEARTBEAT_MS;
      api.post("/auth/heartbeat", { active, interval_seconds: HEARTBEAT_MS / 1000 }).catch(() => {});
    }, HEARTBEAT_MS);

    chk = setInterval(async () => {
      const t = timeoutMin.current;
      if (!t) return;
      const idleMin = (Date.now() - lastActivity.current) / 60000;
      if (idleMin >= t) {
        clearInterval(hb); clearInterval(chk);
        await logout();
        toast.info("You were signed out due to inactivity.");
        nav("/login?idle=1");
      }
    }, CHECK_MS);

    return () => {
      mounted = false;
      events.forEach((e) => window.removeEventListener(e, bump));
      clearInterval(hb); clearInterval(chk);
    };
  }, [logout, nav]);

  return null;
}
